import React, { useEffect } from 'react';
import NavBar from './NavBar';
import './Docs.css';

function Docs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="docs-page">
      <NavBar />

      <section className="docs-hero">
        <div className="docs-hero-content">
          <h1>Documentation</h1>
          <p className="docs-subtitle">Coming Soon</p>
        </div>
      </section>

      <div className="docs-content">
        <section className="docs-section">
          <div className="docs-container">
            <h2>Getting Started</h2>
            <p>
              Documentation for Orchestral AI is currently in development.
              In the meantime, you can get started quickly with:
            </p>
            <div className="docs-code-block">
              <code>pip install orchestral-ai</code>
            </div>
            <p>
              Set your API keys and start building intelligent agents right away.
            </p>
            <h3>Quick Start Example</h3>
            <div className="docs-code-block">
              <pre>{`from orchestral import Agent

agent = Agent()
response = agent.run('Hello world!')
print(response.text)`}</pre>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Docs;
